import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { renderHTMLString } from '../../../../helpers';
import { FormBoxInput } from '../../../shared/forms';
import PaymentFormBlock from '../PaymentFormBlock/PaymentFormBlock';

import './SelectDelegateBlock.scss';

export class SelectDelegateBlock extends Component {
  static propTypes = {
    selectedId: PropTypes.string,
    delegateTypes: PropTypes.array,
    onDelegateChange: PropTypes.func,
    location: PropTypes.object,
  };

  componentDidMount() {
    const { delegateTypes = [] } = this.props;
    localStorage.setItem('isShowingDelegateTypes', delegateTypes.length > 1);
  }

  render() {
    const {
      selectedId,
      delegateTypes = [],
      onDelegateChange,
      location,
      t,
    } = this.props;

    return (
      delegateTypes.length > 1 && (
        <div className="c-select-delegate-block">
          <PaymentFormBlock heading={t('event.purchase.delegate-type')}>
            {delegateTypes.map((delegate) => (
              <div
                key={delegate.name}
                className="c-select-delegate-block__item"
              >
                <FormBoxInput
                  type="radio"
                  size="small"
                  name="delegateType"
                  value={delegate.delegateTypeId}
                  label={delegate.name}
                  description={renderHTMLString(delegate.description, location)}
                  checked={selectedId === delegate.delegateTypeId}
                  onChange={onDelegateChange}
                />
              </div>
            ))}
          </PaymentFormBlock>
        </div>
      )
    );
  }
}

export default withTranslation()(SelectDelegateBlock);
